/**
 * @file user.roles.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene los enums de los roles de usuario
 * -----------------------------------------------------
 * @version 1.0.0a
 * @created 2024-12-19
 * @modified 2025-10-17
 * @author Correcta
 * @author Cristina Bosa
 * @copyright © Correcta
 * @license Private
 * */

export const UserRoles = {
  ADMIN: "admin",
  SUPERADMIN: "super_admin",
  USER: "user",
} as const;

export type UserRoles = (typeof UserRoles)[keyof typeof UserRoles];
